import Reviews, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/reviews';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default Reviews;
